declare var window;
export const isPresetEnabled = window.isPresetAllowedForClient;
